import React, { Component } from 'react';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';
import { connect } from 'react-redux';
import { Slider, Tag, Spin } from 'antd';
import { getLinkProduct, formatNumber, getProfileAfterPrd } from '@/utils/utils';
import CountriesSelect from '@/componentWebs/Common/CountriesSelect';
import FilterCategory from '@/componentWebs/Common/FilterCategory';
import RenderStar from '@/componentWebs/RenderStar';
import EncodeUrl from '@/utils/encode';
import Cascaderprovinces from '@/componentWebs/Common/Cascaderprovinces';
import HotelDiaDiemSelect from '@/componentWebs/Common/HotelDiaDiemSelect';
import Pagination from '@/componentWebs/Pagination';

// import 'moment/locale/vi_VN';
// import locale from 'antd/';

import moment from 'moment';

moment.locale('vi');

const pageSize = 8;
let isDidMount = true;

@connect(({ webs: { dataAd } }) => ({
  dataAd,
}))
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromValue: null,
      toValue: null,
      currentInd: '', //  star
      currentIndHotelGroups: [],
      travelHotelGroups: [],
      travelService: [],
      travelServiceInd: [],
      type: '',
      dataIntroduse: [],
      currentIndDetail: [],
      currentIndXemThem: [],
      activeTabs: '',
      range: [0, pageSize - 1],
      pagi: {},
      paramState: {},
      isXemThemLoaiKhachSan: false,
      isXemThemTienIch: false,
      diemDenText: props.diemDenText || '',
      diaDiem: props.diaDiem || [],
      hideNav: null,
      isInternational: props.isInternational || '0',
      textProvinces: props.textProvinces || '',
      loading: true,
      key: Math.random(),
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch({
      type: 'webs/fetchTravelHotelGroups',
      payload: {
        filter: {
          status: '1',
        },
        attributes: 'id,travelHotelGroupName',
      },
      callback: res => {
        if (res.success) {
          if (res.result.list.length) {
            const travelHotelGroups =
              (res &&
                res.result &&
                res.result.list &&
                res.result.list.length > 0 &&
                res.result.list) ||
              [];
            this.setState({
              travelHotelGroups,
            });
          }
        }
      },
    });

    dispatch({
      type: 'webs/fetchTravelService',
      payload: {
        filter: {
          status: '1',
        },
        attributes: 'id,travelServiceName',
      },
      callback: res => {
        if (res.success) {
          if (res.result.list.length) {
            const travelService =
              (res &&
                res.result &&
                res.result.list &&
                res.result.list.length > 0 &&
                res.result.list) ||
              [];
            this.setState({
              travelService,
            });
          }
        }
      },
    });

    this.fetch();

    window.addEventListener('resize', this.resize.bind(this), { passive: true });
    this.resize();
  }

  componentWillReceiveProps(nextProps) {
    const { isInternational, textProvinces } = this.props;
    if (isInternational !== nextProps.isInternational) {
      this.setState({
        isInternational: nextProps.isInternational,
      });
    }
    if (textProvinces !== nextProps.textProvinces) {
      this.setState({
        textProvinces: nextProps.textProvinces,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize.bind(this));
  }

  resize() {
    this.setState({ hideNav: window.innerWidth < 1024 });
  }

  componentDidUpdate() {
    isDidMount = false;
  }

  fetch = () => {
    const { dispatch } = this.props;
    const {
      currentInd,
      currentIndHotelGroups,
      travelServiceInd,
      fromValue,
      toValue,
      activeTabs,
      range,
      diaDiem,
    } = this.state;

    const tfilter = {
      status: '1',
      travelVisaPackagesStatus: '1',
      travelHotelStars: currentInd,
      travelHotelGroupsId: currentIndHotelGroups,
      travelServices: travelServiceInd,
      travelHotelsRoomDealPrice: [fromValue, toValue],

      locations: {
        countries: [diaDiem[0] && Number([diaDiem[0]])],
        provinces: [diaDiem[1] && Number(diaDiem[1])],
      },
    };

    if (!diaDiem || (diaDiem && diaDiem.length === 0)) delete tfilter.locations;

    if (!currentInd || (currentInd && currentInd.length === 0)) delete tfilter.travelHotelStars;

    if (
      (tfilter.travelHotelGroupsId && tfilter.travelHotelGroupsId.length === 0) ||
      !tfilter.travelHotelGroupsId
    )
      delete tfilter.travelHotelGroupsId;

    if ((tfilter.travelServices && tfilter.travelServices.length === 0) || !tfilter.travelServices)
      delete tfilter.travelServices;

    if (!tfilter.travelHotelStars) delete tfilter.travelHotelStars;

    if ((!fromValue && fromValue !== 0) || (!toValue && toValue !== 0))
      delete tfilter.travelHotelsRoomDealPrice;

    let sort = [];

    switch (activeTabs) {
      case '1': {
        sort = ['travelHotelsRoomDealPrice', 'ASC'];
        break;
      }
      case '2': {
        sort = ['travelHotelsRoomDealPrice', 'DESC'];
        break;
      }
      case '3': {
        sort = ['travelHotelStars', 'desc'];
        break;
      }

      default:
        break;
    }

    const queryString = {
      filter: tfilter,
      range,
      sort,
    };

    if (queryString.sort.length === 0) delete queryString.sort;
    this.setState({
      loading: true,
    });
    dispatch({
      type: 'webs/fetchHotel',
      payload: queryString,
      callback: res => {
        if (res.success) {
          if (res.result && res.result.list) {
            const dataIntroduse = (res && res.result && res.result.list) || [];
            this.setState({
              dataIntroduse,
              loading: false,
              pagi: (res && res.result && res.result.pagination) || {},
            });
          }
        }
      },
    });
  };

  handleClickStar = ind => {
    // this.handleCurrent(ind, 'currentInd');
    const { currentInd } = this.state;

    this.setState(
      {
        currentInd: ind !== currentInd ? ind : '',
      },
      () => {
        this.fetch();
      }
    );
  };

  travelHotelGroups = ind => {
    const { currentIndHotelGroups } = this.state;
    const newState = [...currentIndHotelGroups];
    // this.fetch(param)
    if (currentIndHotelGroups.includes(ind)) {
      newState.splice(currentIndHotelGroups.indexOf(ind), 1);
    } else {
      newState.push(ind);
    }

    this.setState(
      {
        currentIndHotelGroups: newState,
      },
      () => {
        this.fetch();
      }
    );
  };

  handleTravelService = ind => {
    const { travelServiceInd } = this.state;
    const newState = [...travelServiceInd];
    // this.fetch(param)
    if (travelServiceInd.includes(ind)) {
      newState.splice(travelServiceInd.indexOf(ind), 1);
    } else {
      newState.push(ind);
    }

    this.setState(
      {
        travelServiceInd: newState,
      },
      () => {
        this.fetch();
      }
    );
  };

  // Xet active tab
  setActiveTab = (active, idVisaList) => {
    const { currentIndVisaList } = this.state;
    let newCurrentVisaList = [...currentIndVisaList];

    const ind = currentIndVisaList.findIndex(x => x.id === idVisaList);

    if (ind !== -1) {
      if (newCurrentVisaList[ind].active === active) {
        newCurrentVisaList = newCurrentVisaList.filter(x => x.id !== idVisaList);
      } else {
        newCurrentVisaList[ind] = { ...newCurrentVisaList[ind], active };
      }
    } else {
      newCurrentVisaList.push({
        id: idVisaList,
        active,
      });
    }

    this.setState({
      currentIndVisaList: newCurrentVisaList,
    });
  };

  handleActive = (id, tab) => {
    const { currentIndVisaList } = this.state;
    const ind = currentIndVisaList.findIndex(x => x.id === id);

    if (ind !== -1) {
      if ((currentIndVisaList[ind] && currentIndVisaList[ind].active) === tab) return 'active';
    }

    return '';
  };

  handleCurrent = (ind, stateName) => {
    this.setState(existingState => {
      if (existingState[stateName].includes(ind)) {
        const newState = [...existingState[stateName]];
        newState.splice(existingState[stateName].indexOf(ind), 1);
        return { [stateName]: newState };
      }
      return { [stateName]: [ind, ...existingState[stateName]] };
    });
  };

  handlePackageDetail = (itemId, packId) => {
    const ind = `${itemId}_${packId}`;
    this.handleCurrent(ind, 'currentIndDetail');
  };

  xemThemGoiDichVU = ind => {
    this.handleCurrent(ind, 'currentIndXemThem');
  };

  handleXemThemArr = (arr, id) => {
    const { currentIndXemThem } = this.state;
    let newArr = [...arr];

    if (!currentIndXemThem.includes(id)) newArr = newArr.slice(0, 4);

    return newArr;
  };

  filterPrice = tab => {
    const { visible } = this.state;
    this.setState(
      {
        activeTabs: tab,
        visible: !visible,
      },
      () => {
        this.fetch();
      }
    );
  };

  onAfterChange = value => {
    this.setState(
      {
        fromValue: value[0],
        toValue: value[1],
      },
      () => {
        this.fetch();
      }
    );
  };

  handleCountries = value => {
    const param = {
      filter: {
        status: '1',
        countries: value,
      },
      // sort: ['travelVisaPackagesDealPrice', activeTabs === "1" ? 'ASC' : "DESC"],
      range: [0, pageSize - 1],
    };

    this.fetch(param);
  };

  handleChangePagi = currentPagesss => {
    const indexOfLastNews = currentPagesss * pageSize; // vị trí của tin cuối cùng trong list được hiển thị
    const indexOfFirstNews = indexOfLastNews - pageSize;

    this.setState(
      {
        range: [indexOfFirstNews, indexOfLastNews - 1],
      },
      () => {
        this.fetch();
      }
    );
  };

  handleXemThemArr = (arr, status) => {
    let newArr = [...arr];

    if (!status) newArr = newArr.slice(0, 4);

    return newArr;
  };

  handleDetail = item => {
    window.location.href = `/danhsach-khach-san/${EncodeUrl(item.travelHotelName)}/${item.id}`;
  };

  handleClear = () => {
    const { visible } = this.state;
    const { isSearch } = this.props;
    // console.log('isSearch: ', isSearch);
    if (isSearch) {
      this.setState(
        {
          fromValue: null,
          toValue: null,
          currentInd: '', //  star
          currentIndHotelGroups: [],
          travelServiceInd: [],
          activeTabs: '',
          range: [0, pageSize - 1],
          visible: !visible,
        },
        () => this.fetch()
      );
    } else {
      this.setState(
        {
          fromValue: null,
          toValue: null,
          currentInd: '', //  star
          currentIndHotelGroups: [],
          travelServiceInd: [],
          activeTabs: '',
          range: [0, pageSize - 1],
          visible: !visible,
          diaDiem: [],
          key: Math.random(),
        },
        () => this.fetch()
      );
    }
  };

  handleChaneProvince = (value, countries) => {
    this.setState(
      {
        diaDiem: value ? [countries, value] : [],
      },
      () => {
        this.fetch();
      }
    );
  };

  render() {
    // const { data } = this.props;
    const {
      fromValue,
      toValue,
      travelHotelGroups,
      currentInd,
      dataIntroduse,
      visible,
      currentIndHotelGroups,
      travelServiceInd,
      travelService,
      activeTabs,
      isXemThemLoaiKhachSan,
      isXemThemTienIch,
      diemDenText,
      pagi,
      diaDiem,
      type,
      hideNav,
      isInternational,
      textProvinces,
      loading,
      key,
    } = this.state;
    // let isInternational = "0"
    // if (diaDiem &&  diaDiem[0]) {
    //   isInternational =  diaDiem[0] === "1" ? "0" : "1"
    // }

    const arrStar = [1, 2, 3, 4, 5];
    const { searchType, imageResize, typeTab } = this.props;

    const boloc = (
      <div className="datVeMayBay__filter-box">
        <div className="datVeMayBay__filter-box__header flex-b-c">
          <div className="title" onClick={() => this.setState({ visible: !visible })}>
            Bộ lọc
          </div>
          <div className="clear" onClick={this.handleClear} style={{ cursor: 'pointer' }}>
            Xóa lọc
          </div>
        </div>
        <div className="datVeMayBay__filter-box__main">
          {/* Một ô filter  */}
          <div className="datVeMayBay__filter-box__rectangle">
            <div className="datVeMayBay__filter-box__title">Khoảng giá</div>
            <div className="wrapper_silder-title">
              <p className="slider-title flex-b-c">
                <span id="min">{fromValue ? formatNumber(fromValue * 1) : 0}₫</span>
                <span id="max">
                  {toValue ? formatNumber(toValue ? toValue * 1 : 50000000) : 50000000}₫
                </span>
              </p>
              <Slider
                className="slider-track-custom"
                range
                step={100000}
                defaultValue={[0, 50000000]}
                value={[fromValue || 0, toValue || 50000000]}
                min={0}
                max={50000000}
                tooltipVisible={false}
                onChange={value =>
                  this.setState({
                    fromValue: value[0],
                    toValue: value[1],
                  })
                }
                onAfterChange={this.onAfterChange}
              />
            </div>
          </div>
          {/* Một ô filter  */}
          <div className="datVeMayBay__filter-box__rectangle">
            <div className="datVeMayBay__filter-box__title">Hạng khách sạn</div>
            <ul className="datVeMayBay__filter-box__checkbox">
              {arrStar &&
                arrStar.length > 0 &&
                arrStar.map(item => (
                  <li
                    className="datVeMayBay__filter-box__checkbox__item"
                    key={item}
                    onClick={() => this.handleClickStar(Number(item))}
                  >
                    <div className="checkbox">
                      {currentInd === item && <i className="fas fa-check" />}
                      {/* <i className="fas fa-check" /> */}
                    </div>
                    <div className="text">
                      <RenderStar number={item} key={item} />
                    </div>
                  </li>
                ))}
            </ul>
          </div>
          {/* Một ô filter  */}
          <div className="datVeMayBay__filter-box__rectangle">
            <div className="datVeMayBay__filter-box__title">Địa điểm</div>

            <div className="wrapper_silder-title">
              {/* <Cascaderprovinces
                onChange={this.handleChaneProvince}
                value={diaDiem}
                allowClear
                placeholder="Chọn tỉnh/TP"
              /> */}
              <HotelDiaDiemSelect
                value={diaDiem[1] && Number.isInteger(diaDiem[1]) && `${diaDiem[1]}` || diaDiem[1] || undefined}
                isInternational={isInternational}
                disabled={typeTab}
                key={key}
                text={textProvinces}
                placeholder="Chọn tỉnh/TP"
                filter
                onChange={this.handleChaneProvince}
              />
              {/* <CountriesSelect
              placeholder="Chọn nước bạn muốn làm dịch vụ"
              filter
              onChange={this.handleCountries}
            /> */}
            </div>
          </div>

          <div className="datVeMayBay__filter-box__rectangle">
            <div className="datVeMayBay__filter-box__title">Loại khách sạn</div>
            <ul className="datVeMayBay__filter-box__checkbox">
              {travelHotelGroups &&
                travelHotelGroups.length > 0 &&
                this.handleXemThemArr(travelHotelGroups, isXemThemLoaiKhachSan).map(item => (
                  <li
                    className="datVeMayBay__filter-box__checkbox__item"
                    key={item.id}
                    onClick={() => this.travelHotelGroups(item.id)}
                  >
                    <div className="checkbox">
                      {currentIndHotelGroups.includes(item.id) && <i className="fas fa-check" />}
                    </div>
                    <div className="text"> {item.travelHotelGroupName} </div>
                  </li>
                ))}

              {travelHotelGroups && travelHotelGroups.length > 4 && (
                <div
                  onClick={() =>
                    this.setState({
                      isXemThemLoaiKhachSan: !isXemThemLoaiKhachSan,
                    })
                  }
                  style={{
                    cursor: 'pointer',
                    fontSize: '15px',
                    color: '#EB0281',
                    marginTop: '15px',
                  }}
                >
                  {!isXemThemLoaiKhachSan ? 'Xem thêm' : 'Rút gọn'}
                </div>
              )}
            </ul>
          </div>

          <div className="datVeMayBay__filter-box__rectangle">
            <div className="datVeMayBay__filter-box__title">Tiện ích khách sạn</div>
            <ul className="datVeMayBay__filter-box__checkbox">
              {travelService &&
                travelService.length > 0 &&
                this.handleXemThemArr(travelService, isXemThemTienIch).map(item => (
                  <li
                    className="datVeMayBay__filter-box__checkbox__item"
                    key={item.id}
                    onClick={() => this.handleTravelService(Number(item.id))}
                  >
                    <div className="checkbox">
                      {travelServiceInd.includes(Number(item.id)) && <i className="fas fa-check" />}
                    </div>
                    <div className="text"> {item.travelServiceName} </div>
                  </li>
                ))}

              {travelService && travelService.length > 4 && (
                <div
                  onClick={() =>
                    this.setState({
                      isXemThemTienIch: !isXemThemTienIch,
                    })
                  }
                  style={{
                    cursor: 'pointer',
                    fontSize: '15px',
                    color: '#EB0281',
                    marginTop: '15px',
                  }}
                >
                  {!isXemThemTienIch ? 'Xem thêm' : 'Rút gọn'}
                </div>
              )}
            </ul>
          </div>
          <div className="datVeMayBay__filter-box__rectangle hidden-pc">
            <button
              className="btn box-product__btn btnapdung "
              type="button"
              onClick={() => this.setState({ visible: !visible })}
            >
              <span>Áp dụng</span>
            </button>
          </div>
        </div>
      </div>
    );

    const sort = (
      <ul className="datVeMayBay__right-filter__list flex-a-c sortMobile">
        <li className={activeTabs === '3' && 'active'}>
          <span onClick={() => this.filterPrice('3')}>Xếp hạng cao nhất</span>
          <i className="fas fa-times" onClick={() => this.filterPrice('')} />
        </li>
        <li className={activeTabs === '1' && 'active'}>
          <span onClick={() => this.filterPrice('1')}>Giá thấp nhất</span>
          <i className="fas fa-times" onClick={() => this.filterPrice('')} />
        </li>
        <li className={activeTabs === '2' && 'active'}>
          <span onClick={() => this.filterPrice('2')}>Giá giảm dần</span>
          <i className="fas fa-times" onClick={() => this.filterPrice('')} />
        </li>
      </ul>
    );

    return (
      // Tin tức trang chủ
      <React.Fragment>
        {/* {searchType && (
          <div className="khachSan__search-result flex-a-c">
            <div className="name">Khách sạn tại {diemDenText}:</div>
            <div className="result">
              ({pagi && pagi.total}) <span>khách sạn</span>
            </div>
          </div>
        )} */}

        {searchType && (
          <div className="khachSan__search-result hidden-m-t flex-a-c">
            <div className="name">{diemDenText ? `Khách sạn tại ${diemDenText}: ` : `Có:`}</div>
            <div className="result">
              ({pagi && pagi.total}) <span>khách sạn</span>
            </div>
          </div>
        )}
        {/* Product khach san  */}
        <div className="khachSan-products visa-products-wrapper">
          <div className="row boloc hidden-pc row-padding visa-boloc">
            <div
              className="itemBoloc"
              onClick={() => {
                this.setState({ visible: !visible, type: '1' });
              }}
            >
              <img
                src="/static/vietnamTickets/images/Icon feather-filter.svg"
                alt=""
                className="lazyload"
              />
              Bộ lọc
            </div>
            <div
              className="itemBoloc"
              onClick={() => {
                this.setState({ visible: !visible, type: '2' });
              }}
            >
              <img
                src="/static/vietnamTickets/images/Icon awesome-sort-amount-down.svg"
                alt=""
                className="lazyload"
              />
              Sắp xếp
            </div>
          </div>
          <div className="row row-padding">
            <div className="col-lg-3 hidden-m-t">{boloc}</div>
            <div className="col-lg-9 col-padding">
              <div className="khachSan-products__wrapper">
                {/* O filter  */}
                <div className="datVeMayBay__right-filter khachSan__right-filter flex-b-c hidden-m-t">
                  {sort}
                </div>
                {/* lisst  */}
                <Spin spinning={loading}>
                  {dataIntroduse && dataIntroduse.length > 0 ? (
                    <ul className="khachSan-products__list">
                      {dataIntroduse.map(item => (
                        <li className="khachSan-products__item flex-a-c" key={item.id}>
                          <div className="row row-padding">
                            <div className="col-lg-4 col-padding">
                              <div
                                className="khachSan-products__img"
                                onClick={() => this.handleDetail(item)}
                              >
                                <img
                                  src={getResponsiveImage(
                                    item.travelHotelImage &&
                                    item.travelHotelImage[0] &&
                                    item.travelHotelImage[0].file
                                    , imageResize)}
                                  className="lazyload"
                                  alt={item.travelHotelName}
                                />
                              </div>
                            </div>
                            <div className="col-lg-8 col-padding">
                              <div className="khachSan-products__detail">
                                <div className="khachSan-products__places flex-b-c">
                                  <div className="places">
                                    <i className="fas fa-map-marker-alt" />
                                    {`${item.provinces &&
                                      item.provinces.provinceName}, ${item.provinces &&
                                      item.provinces.countries &&
                                      item.provinces.countries.countrieName}`}
                                  </div>
                                  {/* <div className="salesOff">
                                  -15%
                              </div> */}
                                </div>
                                <div
                                  className="khachSan-products__title"
                                  onClick={() => this.handleDetail(item)}
                                >
                                  {item.travelHotelName}
                                </div>
                                <div className="khachSan-products__rated flex-a-c">
                                  <div className="rated">
                                    <RenderStar number={item.travelHotelStars} />
                                  </div>
                                  {/* <div className="text">(85) đánh giá</div> */}
                                </div>
                                <div className="khachSan-products__info flex-b-c">
                                  {item.travelHotelsServices &&
                                    item.travelHotelsServices.length > 0 && (
                                      <ul className="khachSan-products__tieuChi flex">
                                        {item.travelHotelsServices.map(service => (
                                          <li key={service.id}>
                                            <img
                                              src={
                                                (service.travelServiceIcon &&
                                                  service.travelServiceIcon[0] &&
                                                  service.travelServiceIcon[0].file &&
                                                  getResponsiveImage(
                                                    service.travelServiceIcon[0].file
                                                  )) ||
                                                '/static/vietnamTickets/images/Group 8863.svg'
                                              }
                                              className="img-service-detail lazyload"
                                              alt={service.travelServiceName}
                                            />
                                            <div className="text">{service.travelServiceName}</div>
                                          </li>
                                        ))}
                                      </ul>
                                    )}

                                  <div className="khachSan-products__prices">
                                    <div className="products__prices">
                                      {item.travelHotelsRoomPrice !==
                                        item.travelHotelsRoomDealPrice && (
                                          <div className="prices">
                                            {formatNumber(item.travelHotelsRoomPrice)}đ / đêm
                                          </div>
                                        )}

                                      <div className="dealPrices">
                                        {formatNumber(item.travelHotelsRoomDealPrice)}đ /{' '}
                                        <span> đêm</span>
                                      </div>
                                    </div>

                                    <button
                                      className="btn box-product__btn flex-a-c hidden-m-t"
                                      type="button"
                                      onClick={() => this.handleDetail(item)}
                                    >
                                      <span>Đặt ngay</span>
                                      <i className="fas fa-long-arrow-alt-right" />
                                      {/* <i className="fas fa-long-arrow-alt-right"></i> */}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {item.travelHotelsRoomPrice &&
                            item.travelHotelsRoomDealPrice &&
                            item.travelHotelsRoomPrice !== item.travelHotelsRoomDealPrice && (
                              <div className="salesOff">
                                -
                                {Math.round(
                                  ((Number(item.travelHotelsRoomPrice) -
                                    Number(item.travelHotelsRoomDealPrice)) /
                                    Number(item.travelHotelsRoomPrice)) *
                                  100
                                ) || 0}
                                %
                              </div>
                            )}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <>
                      {searchType ? (
                        <div className="no-result">
                          {loading ? '' : 'Không tìm thấy khách sạn phù hợp'}
                        </div>
                      ) : (
                        ''
                      )}
                    </>
                    // <>
                    //   {isDidMount ? (
                    //     ''
                    //   ) : (
                    //     <h2
                    //       style={{
                    //         width: '100%',
                    //         textAlign: 'center',
                    //         fontSize: 20,
                    //         marginTop: '20px',
                    //       }}
                    //     >
                    //       Không tìm thấy khách sạn phù hợp
                    //     </h2>
                    //   )}
                    // </>
                  )}
                </Spin>

                {pagi.total > pageSize - 1 && (
                  <Pagination
                    style={{ textAlign: 'right', marginTop: '20px' }}
                    onChange={this.handleChangePagi}
                    current={pagi && pagi.current}
                    total={pagi && pagi.total}
                    pageSize={pageSize}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {hideNav && (
          <FilterCategory visibleDrawer={visible} type={type}>
            {type === '1' && boloc}
            {type === '2' && sort}
          </FilterCategory>
        )}
      </React.Fragment>
    );
  }
}

export default Index;
